import dayjs from 'dayjs';
import { Paragraph } from '@quickmd-llc/design-system';
import { VisitDetail } from '@qmd-types/visits';

type Props = {
  visit: VisitDetail;
};

function VisitContext({ visit }: Props) {
  const { dateTime, visitType } = visit;
  const visitTime = dayjs(dateTime).format('MM/DD/YYYY');

  return (
    <Paragraph>
      For your <span className="font-medium">{visitType.name}</span> visit on{' '}
      <span className="font-medium">{visitTime}</span>
    </Paragraph>
  );
}

export { VisitContext };
